<!-- 上传问题反馈图片 -->
<template>
  <div class="imgWarp flex_row">
    <div v-for="(item,index) in fileList" class="item_img" >
      <img :src="item" >
      <div class="btns">
        <i class="el-icon-zoom-in" @click="handlePictureCardPreview(item)" />
        <i class="el-icon-delete" @click="handleRemove(index)" />
      </div>
    </div>
    <el-upload list-type="picture-card" :show-file-list="false" :auto-upload="false" :limit="5" action="#"
      :on-change="handleChange" >
      <i slot="default" class="el-icon-plus"></i>
    </el-upload>

    <el-dialog :visible.sync="dialogVisible" append-to-body>
      <img width="100%" :src="dialogImageUrl">
    </el-dialog>

  </div>
</template>

<script>
import { uploadImg } from '@/api/feedBack'
export default {
  components: {},
  model: {
    prop: 'fileList',
    event: 'change'
  },
  props: ['fileList'],
  data () {
    return {
      dialogVisible: false,
      dialogImageUrl: '',
      disabled: false
    };
  },
  mounted () {
  },
  methods: {
    handleRemove(index) {
      this.fileList.splice(index, 1)
    },
    handlePictureCardPreview (url) {
      this.dialogImageUrl = url;
      this.dialogVisible = true;
    },
    handleChange (file) { // 新增意见弹窗--图片上传
      if (this.uploadImgTime == file.uid) return
      this.uploadImgTime = file.uid
      var houzui = '' // 上传文件的格式
      if (file.name.indexOf('.') > -1) {
        var arr = file.name.split('.')
        houzui = arr[arr.length - 1].toLowerCase()
      }

      if (houzui != 'jpg' && houzui != 'png' && houzui != 'jpeg') {
        this.$message({
          type: 'error',
          message: this.$t('feedBack.formatWrong') // 格式不对，请上传图片！
        })
        return
      } else if (file.size > 10 * 1024 * 1024) {
        this.$message({
          type: 'error',
          message: this.$t('feedBack.overSize') // 图片大小不能超过10M，请重试！
        })
        return
      }
      uploadImg(file).then(res => {
        if (res.resultCode == 1001) {
          this.fileList.push( res.resultModel )
          
        } else {
          this.$message({
            type: 'error',
            message: this.$t('feedBack.ImgUploadFailed') // 图片上传失败，请重试！
          })
        }
      })
    }
  }
}
</script>

<style lang='scss' scoped>
.item_img {
  position: relative;
  width: 100px;
  height: 100px;
  overflow: hidden;
  border-radius: 8px;
  margin-right: 10px;
  img {
    max-width: 100%;
    min-height: 100%;
  }
  .btns {
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    background-color: rgba($color: #000000, $alpha: 0.5);
    color: #fff;
    font-size: 16px;
    text-align: center;
    line-height: 100px;
    i {
      cursor: pointer;
      margin: 0 10px;
    }
  }
}
</style>
